import { TextField } from '@mui/material';

interface NameFieldProps {
  value: string;
  error?: string;
  setValue: (value: string) => void;
}

function NameField({ value, error, setValue }: NameFieldProps): React.JSX.Element {
  return (
    <TextField
      fullWidth
      required
      label='Name'
      value={value}
      error={Boolean(error)}
      helperText={error}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}

export default NameField;

